import React from "react";
import { Navigate } from "react-router-dom";

export default function OngletPlanningThoraciqueAccesMedecins() {
  // Converge vers la meme page de gestion que l'astreinte thoracique.
  const back = encodeURIComponent(
    `${window.location.pathname}${window.location.search || ""}`
  );
  return (
    <Navigate
      to={`/responsable/gardes-liste-medecins?type=ASTREINTE_THORACIQUE&back=${back}`}
      replace
    />
  );
}
